import { EPaymentStatus, EProductStatus } from 'redux/reducers/gpsr/types';

export const PRODUCT_STATUS_NAMES = {
	[EProductStatus.EAS_NOT_STARTED]: 'No Products Added',
	[EProductStatus.EM_NOT_STARTER]: 'No SKU added',
	[EProductStatus.EM_SKU_STARTED]: 'No DoC started',
	[EProductStatus.EM_NOT_FINISHED]: 'No all DoC finished',
	[EProductStatus.ALL_IS_DONE]: 'All is Done',
};

export const PAYMENT_STATUS_NAMES = {
	[EPaymentStatus.PAID]: 'Paid',
	[EPaymentStatus.PENDING]: 'Pending',
	[EPaymentStatus.PARTIALLY_PAID]: 'Partially Paid',
};
